import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private urlsToHideHeader = ['/logout'];

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        if (this.urlsToHideHeader.includes(event.url)) {
          this.isHeaderVisible = false;
        } else {
          this.isHeaderVisible = true;
        }
      });
  }

  public isHeaderVisible = true;

  public hide(): void {
    this.isHeaderVisible = false;
  }

  public show(): void {
    this.isHeaderVisible = true;
  }
}
